import React, { useState, useEffect } from "react"
import { connect } from "react-redux"

import { withTranslation } from "react-i18next"
import {
  getGppByGpId,
  getListEngineer,
  projectProcess,
  resetGasProcessFlag,
  resetGasProjectFlag,
} from "store/actions"
import { getCurrentUser } from "helpers/service_helper"
import "./gasProjectProcess.scss"

import {
  Layout,
  Button,
  Row,
  Col,
  notification,
  Card,
  Space,
  Typography,
  Flex,
  Breadcrumb,
} from "antd"
import {
  SaveOutlined,
  CheckCircleOutlined,
  HomeOutlined,
} from "@ant-design/icons"
const { Title, Text } = Typography
import { ListEngineer } from "./ListEngineer"
import ListGasProject from "./ListGasProject"

notification.config({
  duration: 2,
  rtl: true,
})

const Index = props => {
  const {
    matches_sm,
    loading,
    selectedProject,
    countSelectedProject,
    onProjectProcess,
    flatSelectedProject,
    triggerReload,
    onResetGasProcessFlag,
    onResetGasProjectFlag
  } = props
  const [api, contextHolder] = notification.useNotification()
  const [errorMessage, setErrorMessage] = useState(null)
  const [idEngineer, setIdEngineer] = useState(null)

  const openNotification = (type, placement, message) => {
    api[type]({
      message,
      placement,
    })
  }

  useEffect(() => {
    if (props.success) openNotification("success", "top", props.success)
    if (props.error) openNotification("error", "top", props.error)
    if (errorMessage) openNotification("warning", "top", props.error)
    onResetGasProcessFlag()
  onResetGasProjectFlag()
  }, [errorMessage, props.success, props.error])

  const saveProjectProcess = async () => {
    console.log("flatSelectedProject", flatSelectedProject.projectId)
    if (flatSelectedProject.projectId.length > 0 && idEngineer !== null)
      await onProjectProcess({
        IdGasProjects: flatSelectedProject.projectId,
        IdEngineer: idEngineer,
      })
  }

  const isAdmin = getCurrentUser().role === "Administrator"

  return (
    <>
      <div className="page-content">
        {contextHolder}

        {/* Main Content Card */}
        <Card
          style={{
            borderRadius: 16,
            boxShadow: "0 4px 12px rgba(0,0,0,0.08)",
            marginBottom: 16,
          }}
          bodyStyle={{ padding: 0 }}
        >
          {/* Header Section */}
          <div
            style={{
              background: "linear-gradient(135deg, #1890ff 0%, #096dd9 100%)",
              padding: "16px 16px",
              borderRadius: "16px 16px 0 0",
            }}
          >
            <Flex justify="space-between" align="center" wrap="wrap" gap={16}>
              {/* Breadcrumb */}
              <Breadcrumb
                items={[
                  {
                    href: "/",
                    title: (
                      <HomeOutlined
                        style={{ color: "rgba(255,255,255,0.7)" }}
                      />
                    ),
                  },
                  {
                    title: (
                      <span style={{ color: "rgba(255,255,255,0.7)" }}>
                        {props.t("gasUnit")}
                      </span>
                    ),
                  },
                  {
                    title: <span style={{ color: "#fff" }}>تخصیص پرونده</span>,
                  },
                ]}
                separator={
                  <span style={{ color: "rgba(255,255,255,0.5)" }}>/</span>
                }
              />
              {/* Stats */}
              <Space size={24}>
                <div
                  style={{
                    background: "rgba(255,255,255,0.15)",
                    padding: "8px 16px",
                    borderRadius: 8,
                    backdropFilter: "blur(10px)",
                  }}
                >
                  <Space>
                    <CheckCircleOutlined
                      style={{ color: "#fff", fontSize: 18 }}
                    />
                    <Text strong style={{ color: "#fff", fontSize: 15 }}>
                      تعداد انتخابی: {countSelectedProject || 0}
                    </Text>
                  </Space>
                </div>
              </Space>
            </Flex>
          </div>

          {/* Admin Assignment Section */}
          {isAdmin && (
            <div
              style={{
                padding: "8px 8px",
                background: "#fafafa",
                borderBottom: "1px solid #f0f0f0",
              }}
            >
              <Row gutter={[16, 16]} align="middle">
                <Col xs={24} sm={24} md={24} lg={20}>
                  <Card
                    size="small"
                    style={{
                      borderRadius: 12,
                      border: "1px solid #e6f7ff",
                      background: "#e6f7ff",
                    }}
                  >
                     
                        <ListEngineer
                          openNotification={openNotification}
                          selectEngineer={setIdEngineer}
                          props={props}
                        />
                  </Card>
                </Col>
                <Col xs={24} sm={24} md={24} lg={4}>
                  <Button
                    type="primary"
                    size="large"
                    icon={<SaveOutlined />}
                    loading={loading}
                    disabled={!idEngineer || countSelectedProject === 0}
                    onClick={saveProjectProcess}
                    block
                    style={{
                      height: 48,
                      borderRadius: 10,
                      background:
                        countSelectedProject > 0 && idEngineer
                          ? "linear-gradient(135deg, #52c41a 0%, #389e0d 100%)"
                          : undefined,
                      border: "none",
                      fontWeight: 500,
                    }}
                  >
                    ذخیره تخصیص
                  </Button>
                </Col>
              </Row>
            </div>
          )}

          {/* List Section */}
          <div style={{ padding: "20px 24px" }}>
            <ListGasProject
              openNotification={openNotification}
              reload={triggerReload}
            />
          </div>
        </Card>
      </div>
    </>
  )
}



const mapStateToProps = ({ USERs, GasProjectProcesses, Engineers }) => ({
  lstEngineer: Engineers.lstEngineer,
  loading: GasProjectProcesses.loading,
  lstGpp: GasProjectProcesses.lstGpp,
  error: GasProjectProcesses.error,
  success: GasProjectProcesses.success,
  userBalance: USERs.userBalance,
  selectedProject: GasProjectProcesses.selectedProject,
  countSelectedProject: GasProjectProcesses.countSelectedProject,
  flatSelectedProject: GasProjectProcesses.flatSelectedProject,
  triggerReload: GasProjectProcesses.triggerReload,
})

const mapDispatchToProps = dispatch => ({
  onGetGppByGpId: gasProjectId => dispatch(getGppByGpId(gasProjectId)),
  onGetListEngineer: () => dispatch(getListEngineer()),
  onProjectProcess: data => dispatch(projectProcess(data)),
  onResetGasProcessFlag: () => dispatch(resetGasProcessFlag()),
  onResetGasProjectFlag: () => dispatch(resetGasProjectFlag()),
})

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withTranslation()(Index))
